module.exports = __webpack_public_path__ + "static/media/download_gm.79c97a21.svg";